export default __webpack_public_path__ + "static/media/incorrect.da014ec1.svg";